import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../../../auth/auth-guard.guard";
import { CanDeactivateGuard } from "../../api/url-guards/can-deactivate.guard";
import { ClincalCompletedComponent } from "./clinical/clincal-completed/clincal-completed.component";
import { ClinicalOrFeedbackComponent } from "./clinical/clinical-orfeedback/clinical-orfeedback.component";
import { ClinicalComponent } from "./clinical/clinical.component";
import { DocumentReviewerComponent } from "./document-reviewer/document-reviewer.component";
import { PendsComponent } from "./pends/pends.component";
import { RetrievalComponent } from "./retrieval/retrieval.component";
import { RetrievalResolve } from "./retrieval/retrieval.resolve";

const routes: Routes = [
  {
    path: "retrieval",
    component: RetrievalComponent, canActivate: [AuthGuard],
    resolve: {
      userModel: RetrievalResolve,
    },
  },

  { path: "completed", component: ClincalCompletedComponent},
  { path: "clinical", component: ClinicalComponent, canActivate: [AuthGuard], data: { defaultPath: "/dashboard/clinical" } },
  { path: "clinical/orfeedback", component: ClinicalOrFeedbackComponent},
  { path: "documentreviewer", component: DocumentReviewerComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
  { path: "pends", component: PendsComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule { }
